// extracted by mini-css-extract-plugin
module.exports = {"Awards":"Awards_Awards__1QbKK"};